import type { AvatarStyle } from "@/types/avatar";

/**
 * 利用可能なアバタースタイル一覧
 */
export const AVATAR_STYLES: readonly AvatarStyle[] = [
  { id: "bottts-neutral", nameKey: "settings.avatar.styles.robot" },
  { id: "avataaars-neutral", nameKey: "settings.avatar.styles.character" },
  { id: "identicon", nameKey: "settings.avatar.styles.geometric" },
  { id: "shapes", nameKey: "settings.avatar.styles.abstract" },
  { id: "thumbs", nameKey: "settings.avatar.styles.thumbs" },
  { id: "initials", nameKey: "settings.avatar.styles.initials" },
] as const;

/**
 * デフォルトのアバタースタイル
 */
export const DEFAULT_AVATAR_STYLE = "bottts-neutral" as const;

/**
 * DiceBear API のベースURL
 */
export const DICEBEAR_API_BASE = "https://api.dicebear.com/9.x" as const;
